const CURRENCY_FORMAT = Intl.NumberFormat('en-US', {
    style: 'decimal',
});

const FORMAT_KEYS = ['value', 'price'];

export default function sendEvent(event, options) {
    let attributes = options;

    // filter empty objects
    attributes.items = attributes.items.filter(value => Object.keys(value).length !== 0);

    // format currency
    attributes = formatCurrency(attributes);
    attributes.items = attributes.items.map(item => formatCurrency(item));

    if (attributes.items.length > 0) {
        // empty datalayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ecommerce: null});

        // send event
        window.dataLayer.push({
            event, ecommerce: attributes,
        });
    }
}

function formatCurrency(options = {}) {
    FORMAT_KEYS.forEach(key => {
        if (options.hasOwnProperty(key)) {
            options[key] = CURRENCY_FORMAT.format(options[key]);
        }
    });

    return options;

}
